module.exports = __webpack_public_path__ + "static/media/pws.539c6b38.svg";